export default __webpack_public_path__ + "static/media/04.57f85328.jpg";